// https://stackoverflow.com/questions/44065854/make-button-group-look-like-radio-button

import React, { Component} from 'react';
import { Map } from '../Map'

class GenreButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStatus: 'inactive',
      effectAll: 'deselect',
      "農業": true,
      "漁業": true,
      "工場": true,
      "林業": true,
      "建設": true,
      "交通": true,
      "防災": true,
      "防犯": true,
      "防災・減災": true,
      "働き方": true,
      "発電所": true,
      "モビリティ": true,
      "インフラ": true,
      "空港・港湾": true,
      "鉄道・道路": true,
      "観光・eスポーツ": true,
      "医療・ヘルスケア": true,
      "スマートシティ": true,
      "文化・スポーツ": true,
      "放送": true,
      '工場・発電所等':true,
      '河川': true,
      '道路': true,
      '鉄道': true,
      'その他': true
    };

    this.clickHandler = this.clickHandler.bind(this);
    this.clickEffectAll = this.clickEffectAll.bind(this);
  }

  componentDidMount () {
    this.props.parentMethod(this)
  }

  setIdToState(id) {
    this.setState((state) => {
      return {[id]: !state[id]}
    }, function() {
      this.props.onChange(this.state);
      let cnt = 0
      Object.keys(this.state).map((s) => {
        if (this.state[s] === true) {
          cnt++
        }
      })
      if (cnt === this.props.options.length) {
        this.state.effectAll = 'deselect'
      } else {
        this.state.effectAll = 'select'
      }
    });
  }
  clickHandler(e) {
    const id = e.target.textContent
    this.setIdToState(id)
  };
  async clickEffectAll() {
    let effect
    if (this.state.effectAll === 'select') {
      effect = true
      this.state.effectAll = 'deselect'
    } else if (this.state.effectAll === 'deselect') {
      effect = false
      this.state.effectAll = 'select'
    }
    await Promise.all(this.props.options.map(async (id) => {
      this.setState(() => {
        return {[id]: effect}
      })
    }))
    .then(response => {
      this.props.onChange(this.state);
    })
  }

  render() {
    return (
      <div
        style={{
          justifyContent: 'center',
          flexDirection: 'row',
          flexWrap: 'wrap',
          marginTop: 20,
          marginBottom: 20,
        }}
      >

        {this.props.options.map((option, idx) => {
          let classText = ''
          switch (option) {
            case '農業':
              classText = 'agriculture'
              break
            case '漁業':
              classText = 'fishing'
              break
            case '工場':
              classText = 'factory'
              break
            case '林業':
              classText = 'forestry'
              break
            case '建設':
              classText = 'construction'
              break
            case '交通':
              classText = 'traffic'
              break
            case '防災':
              classText = 'disaster'
              break
            case '防犯':
              classText = 'crime'
              break
            case '防災・減災':
              classText = 'mitigation'
              break
            case '働き方':
              classText = 'work'
              break
            case '発電所':
              classText = 'plant'
              break
            case 'モビリティ':
              classText = 'mobility'
              break
            case 'インフラ':
              classText = 'infrastructure'
              break
            case '空港・港湾':
              classText = 'airport'
              break
            case '鉄道・道路':
              classText = 'railroad'
              break
            case '観光・eスポーツ':
              classText = 'sightseeing'
              break
            case '医療・ヘルスケア':
              classText = 'medical'
              break
            case 'スマートシティ':
              classText = 'smartcity'
              break
            case '文化・スポーツ':
              classText = 'culture'
              break
            case '放送':
              classText = 'broadcast'
              break
            default:
              break
          }

          return (
            <button
              onClick={
                this.clickHandler
              }
              className={`genre genre-${classText} ${this.state[`${option}`]? "active":"inactive"}`}
              data-id={`${classText}`}
              key={idx}
            >
            <span>{option}</span>
          </button>
          )
        })}
        <button className="effectAll" onClick={this.clickEffectAll}> {(this.state.effectAll === 'select') ? 'すべて選択':'すべて解除' }</button>
      </div>
    );
  }
}

export default GenreButton